// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1wIAd","inner":"Footer_inner__10_6j"};